import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { baseApi } from "./api/base";
import { authApi } from "./api/auth";
import { checklistApi } from "./api/checklist";
import { fleetApi } from "./api/fleet";
import { marinerApi } from "./api/mariner";
import { rtkQueryErrorLogger } from "./api/middleware/rtkQueryErrorLogger";
import { profileDocumentApi } from "./api/profileDocument";
import { travelDocumentApi } from "./api/travelDocument";
import { userApi } from "./api/user";
import { vesselApi } from "./api/vessel";
import { emailApi } from "./api/email";
import authReducer from "./authentication/authSlice";
import { jobApplicationApi } from "./api/jobApplication";
import { unionApi } from "./api/union";
import { trainingApi } from "./api/training";
import { evaluationApi } from "./api/evaluation";
import { trainingDocumentApi } from "./api/trainingDocument";
import { trainingOrderApi } from "./api/trainingOrder";
import { complianceTrainingApi } from "./api/complianceTraining";
import vesselEmailReducer from "./vessel/vesselEmailSlice";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["accessToken", "idToken", "refreshToken", "user"],
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

const store = configureStore({
  reducer: {
    [checklistApi.reducerPath]: checklistApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    [marinerApi.reducerPath]: marinerApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [vesselApi.reducerPath]: vesselApi.reducer,
    [fleetApi.reducerPath]: fleetApi.reducer,
    [profileDocumentApi.reducerPath]: profileDocumentApi.reducer,
    [travelDocumentApi.reducerPath]: travelDocumentApi.reducer,
    [emailApi.reducerPath]: emailApi.reducer,
    [jobApplicationApi.reducerPath]: jobApplicationApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [unionApi.reducerPath]: unionApi.reducer,
    [trainingApi.reducerPath]: trainingApi.reducer,
    [trainingOrderApi.reducerPath]: trainingOrderApi.reducer,
    [complianceTrainingApi.reducerPath]: complianceTrainingApi.reducer,
    [evaluationApi.reducerPath]: evaluationApi.reducer,
    [trainingDocumentApi.reducerPath]: trainingDocumentApi.reducer,
    auth: persistedAuthReducer,
    vesselEmail: vesselEmailReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(rtkQueryErrorLogger)
      .concat(checklistApi.middleware)
      .concat(baseApi.middleware)
      .concat(marinerApi.middleware)
      .concat(userApi.middleware)
      .concat(vesselApi.middleware)
      .concat(fleetApi.middleware)
      .concat(profileDocumentApi.middleware)
      .concat(travelDocumentApi.middleware)
      .concat(emailApi.middleware)
      .concat(jobApplicationApi.middleware)
      .concat(authApi.middleware)
      .concat(unionApi.middleware)
      .concat(trainingApi.middleware)
      .concat(trainingDocumentApi.middleware)
      .concat(trainingOrderApi.middleware)
      .concat(complianceTrainingApi.middleware)
      .concat(evaluationApi.middleware),

  devTools: process.env.NODE_ENV !== "production",
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

export default store;
